//name : ie | opera
const browserList = [
  {
    name: 'edge',
    version: 15
  },
  {
    name: 'firefox',
    version: 52
  },
  {
    name: 'chrome',
    version: 54
  },
  {
    name: 'safari',
    version: 10
  },
  {
    name: 'chrome_mobile',
    version: 55
  },
  {
    name: 'firefox_mobile',
    version: 50
  },
  {
    name: 'firefox_ios',
    version: 25
  },
  {
    name: 'mobile_safari',
    version: 10
  },
  {
    name: 'chrome_mobile_ios',
    version: 55
  }
];
export default browserList;
